import Book01 from "./Book01";

function main() {
  return (
    <div>
      <Book01 />
    </div>
  );
}

export default main;
